import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import {
  catchError,
  exhaustMap,
  map,
  pluck,
  share,
  switchMap,
} from 'rxjs/operators';

import { AuthService } from 'src/app/services/api/auth.service';

import * as AuthActions from '../actions/auth/auth.actions';

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private authApi: AuthService,
  ) {}

  setToken$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.setToken),
      ),
    { dispatch: false },
  );

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.login),
      exhaustMap((action) =>
        this.authApi.login(action.email, action.password, action.remember).pipe(
          map((token) =>
            AuthActions.loginSuccess({
              token,
              remember: action.remember,
            }),
          ),
          catchError((e) => of(AuthActions.loginFailed({ error: e }))),
        ),
      ),
      share(),
    ),
  );

  loginSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.loginSuccess),
      map(({ token }) =>
        AuthActions.setToken({ token }),
      ),
      share(),
    ),
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.logout),
      exhaustMap(() =>
        this.authApi.logout().pipe(
          map(() => AuthActions.logoutSuccess()),
          catchError(() => of(AuthActions.logoutSuccess())),
        ),
      ),
    ),
  ).pipe(share());

  forgotPassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.forgotPassword),
      pluck('email'),
      exhaustMap((email) =>
        this.authApi.forgotPassword(email).pipe(
          map(() => AuthActions.forgotPasswordSuccess()),
          catchError((e) => of(AuthActions.forgotPasswordFailed({ error: e }))),
        ),
      ),
      share(),
    ),
  );
  resetPassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.resetPassword),
      exhaustMap(({ _id, password, token }) =>
        this.authApi.resetPassword(_id, password, token).pipe(
          map(() => AuthActions.resetPasswordSuccess()),
          catchError((error) => of(AuthActions.resetPasswordFailed({ error }))),
        ),
      ),
      share(),
    ),
  );
}
